import { useEffect, useState } from 'react'
import { usePermissions } from '../admin/primitives.js'
import { chargerSynthese } from './signalements-api.js'
import { compte, type ErreurSig, type Synthese } from './signalements-model.js'

/**
 * SIGNALEMENTS — LE COMPTE RÉEL DE LA TUILE DU HUB TECHNIQUE (09/10/2026).
 *
 * Technique est la source de vérité : la tuile lit `/summary` à l'ouverture
 * du hub et n'en garde rien. Doctrine « tuile = navigation » : un compte, une
 * phrase, la flèche de la tuile — ni table, ni action. Sans le droit de
 * lecture, aucun appel ne part (la tuile elle-même est déjà masquée).
 * Technique absent : la tuile le dit, sans chiffre inventé ni nouvel essai —
 * et dit POURQUOI : « momentanément indisponible » (une panne passagère) n'est
 * pas « non raccordé » (l'adresse de Technique retirée du serveur,
 * l'interrupteur du domaine), la phrase que la liste affiche pour la même
 * cause.
 */
export function SyntheseSignalements() {
  const { permissions, loading } = usePermissions()
  const peutLire = !loading && permissions.includes('technique.signalements.read')
  const [s, setS] = useState<Synthese | null>(null)
  const [erreur, setErreur] = useState<ErreurSig | null>(null)

  useEffect(() => {
    if (!peutLire) return
    let vivant = true
    void chargerSynthese().then((r) => {
      if (!vivant) return
      if (r.ok) setS(r.data)
      else setErreur(r.erreur)
    })
    return () => { vivant = false }
  }, [peutLire])

  if (!peutLire) return null
  if (erreur) {
    return (
      <span className="fh-tile__synthese fh-tile__synthese--muette">
        {erreur.genre === 'non_configure' ? 'Technique non raccordé'
          : erreur.genre === 'indisponible' ? 'Technique momentanément indisponible' : 'Compte indisponible'}
      </span>
    )
  }
  if (!s) return <span className="fh-tile__synthese" aria-busy="true">…</span>
  if (s.ouverts === 0) return <span className="fh-tile__synthese">Aucun signalement ouvert</span>
  return (
    <span className="fh-tile__synthese">
      <strong className="fh-tile__compte">{compte(s.ouverts, 'ouvert', 'ouverts')}</strong>
      <span className="fh-tile__detail">
        {compte(s.priorite_elevee, 'en priorité élevée', 'en priorité élevée')} · {compte(s.non_affectes, 'non affecté', 'non affectés')}
      </span>
    </span>
  )
}
